// Volo.Abp.Identity.IdentityPermissions.Roles.
export const IdentityRolePermissions = {
  view: 'AbpIdentity.Roles',
  create: 'AbpIdentity.Roles.Create',
  update: 'AbpIdentity.Roles.Update',
  delete: 'AbpIdentity.Roles.Delete',
  managePermissions: 'AbpIdentity.Roles.ManagePermissions',
} as const;
